import { useContextOrThrow } from "src/utils/useContextOrThrow.tsx";
import {
	GenericDialogContext,
	GenericDialogContextValue,
} from "src/components/common/dialogs/GenericDialogProvider.tsx";

export const useGenericDialog = (): GenericDialogContextValue =>
	useContextOrThrow(GenericDialogContext);
